"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withReduxForm = _interopRequireDefault(require("../../libs/hocs/withReduxForm"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _constants = require("../../libs/constants");

var _utils = require("../../libs/utils");

var _outsideClick = _interopRequireDefault(require("../../libs/outsideClick"));

var _scrollController = require("../../libs/scrollController");

var _label = _interopRequireDefault(require("../Input/label"));

var _getNormalizeValue2 = _interopRequireDefault(require("./helpers/getNormalizeValue"));

var _shouldOpenMenu = _interopRequireDefault(require("./helpers/shouldOpenMenu"));

var _input = _interopRequireDefault(require("./styled/input"));

var _container = _interopRequireDefault(require("./styled/container"));

var _innerContainer = _interopRequireDefault(require("./styled/innerContainer"));

var _icon = _interopRequireDefault(require("./styled/icon"));

var _errorText = _interopRequireDefault(require("../Input/styled/errorText"));

var _indicator = _interopRequireDefault(require("./styled/indicator"));

var _InternalDropdown = _interopRequireDefault(require("../InternalDropdown"));

var _InternalOverlay = _interopRequireDefault(require("../InternalOverlay"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function positionResolver(opts) {
  var trigger = opts.trigger,
      viewport = opts.viewport,
      content = opts.content;
  var newOpts = {
    trigger: trigger,
    viewport: viewport,
    content: _objectSpread(_objectSpread({}, content), {}, {
      width: trigger.width
    })
  };
  return _objectSpread(_objectSpread({}, _InternalOverlay["default"].defaultPositionResolver(newOpts)), {}, {
    width: trigger.width
  });
}
/**
 * A Picklist provides a user with an read-only input field that is accompanied with
 *  a listbox of pre-defined options.
 * @category Form
 */


var Picklist = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Picklist, _Component);

  var _super = _createSuper(Picklist);

  function Picklist(props) {
    var _this$keyHandlerMap;

    var _this;

    (0, _classCallCheck2["default"])(this, Picklist);
    _this = _super.call(this, props);
    _this.inputId = (0, _utils.uniqueId)('picklist-input');
    _this.errorMessageId = (0, _utils.uniqueId)('error-message');
    _this.listboxId = (0, _utils.uniqueId)('listbox');
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.triggerRef = /*#__PURE__*/_react["default"].createRef();
    _this.dropdownRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleInputClick = _this.handleInputClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPressed = _this.handleKeyPressed.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleContainerClick = _this.handleContainerClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeAndFocusInput = _this.closeAndFocusInput.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWindowScroll = _this.handleWindowScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.outsideClick = new _outsideClick["default"]();
    _this.windowScrolling = new _scrollController.WindowScrolling();
    _this.activeChildren = [];
    _this.state = {
      isOpen: false
    };
    _this.keyHandlerMap = (_this$keyHandlerMap = {}, (0, _defineProperty2["default"])(_this$keyHandlerMap, _constants.ESCAPE_KEY, _this.closeAndFocusInput), (0, _defineProperty2["default"])(_this$keyHandlerMap, _constants.TAB_KEY, _this.closeAndFocusInput), _this$keyHandlerMap);
    return _this;
  }

  (0, _createClass2["default"])(Picklist, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var wasOpen = prevState.isOpen;
      var isOpen = this.state.isOpen;

      if (!wasOpen && isOpen) {
        // eslint-disable-next-line id-length
        this.outsideClick.startListening(this.containerRef.current, function (_, event) {
          if (_this2.eventTarget !== event.target) {
            _this2.closeMenu();
          }
        });
        this.windowScrolling.startListening(this.handleWindowScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.outsideClick.stopListening();
      this.windowScrolling.stopListening();
    }
  }, {
    key: "getErrorMessageId",
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorMessageId;
      }

      return undefined;
    }
  }, {
    key: "handleKeyPressed",
    value: function handleKeyPressed(event) {
      var isOpen = this.state.isOpen;
      var readOnly = this.props.readOnly;

      if (isOpen) {
        if (this.keyHandlerMap[event.keyCode]) {
          return this.keyHandlerMap[event.keyCode]();
        }
      } else if ((0, _shouldOpenMenu["default"])(event.keyCode) && !readOnly) {
        event.preventDefault();
        this.openMenu();
      }

      return null;
    }
  }, {
    key: "handleWindowScroll",
    value: function handleWindowScroll(event) {
      if (this.dropdownRef.current.contains(event.target)) return;
      this.closeMenu();
    }
  }, {
    key: "closeAndFocusInput",
    value: function closeAndFocusInput() {
      this.closeMenu();
      this.focus();
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      var readOnly = this.props.readOnly;

      if (!readOnly) {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.outsideClick.stopListening();
      this.windowScrolling.stopListening();
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "handleInputClick",
    value: function handleInputClick(event) {
      var onClick = this.props.onClick;
      var isOpen = this.state.isOpen;
      onClick(event);

      if (isOpen) {
        return this.closeMenu();
      }

      return this.openMenu();
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var _this$props = this.props,
          onFocus = _this$props.onFocus,
          value = _this$props.value;
      var eventValue = value || null;
      onFocus(eventValue);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var _this$props2 = this.props,
          onBlur = _this$props2.onBlur,
          value = _this$props2.value;
      var eventValue = value || null;
      onBlur(eventValue);
    }
  }, {
    key: "handleChange",
    value: function handleChange(option) {
      var _this3 = this;

      var onChange = this.props.onChange;
      var label = option.label,
          name = option.name,
          icon = option.icon,
          value = option.value;
      this.closeMenu();
      setTimeout(function () {
        _this3.focus();

        return onChange({
          label: label,
          name: name,
          icon: icon,
          value: value
        });
      }, 0);
    }
  }, {
    key: "handleContainerClick",
    value: function handleContainerClick(event) {
      this.eventTarget = event.target;
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: "focus",
    value: function focus() {
      this.triggerRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.triggerRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.triggerRef.current.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          pickListLabel = _this$props3.label,
          labelAlignment = _this$props3.labelAlignment,
          hideLabel = _this$props3.hideLabel,
          style = _this$props3.style,
          className = _this$props3.className,
          variant = _this$props3.variant,
          error = _this$props3.error,
          isLoading = _this$props3.isLoading,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          required = _this$props3.required,
          children = _this$props3.children,
          id = _this$props3.id,
          tabIndex = _this$props3.tabIndex,
          placeholder = _this$props3.placeholder,
          name = _this$props3.name,
          valueInProps = _this$props3.value,
          enableSearch = _this$props3.enableSearch;

      var _getNormalizeValue = (0, _getNormalizeValue2["default"])(valueInProps),
          valueLabel = _getNormalizeValue.label,
          icon = _getNormalizeValue.icon;

      var value = valueLabel || '';
      var errorMessageId = this.getErrorMessageId();
      var isOpen = this.state.isOpen;
      var isReadOnly = !!(!disabled && readOnly);
      return /*#__PURE__*/_react["default"].createElement(_container["default"], {
        id: id,
        role: "presentation",
        className: className,
        style: style,
        onKeyDown: this.handleKeyPressed,
        ref: this.containerRef,
        readOnly: readOnly,
        onClick: this.handleContainerClick
      }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: pickListLabel
      }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
        label: pickListLabel,
        labelAlignment: labelAlignment,
        hideLabel: hideLabel,
        required: required,
        inputId: this.inputId,
        readOnly: isReadOnly
      })), /*#__PURE__*/_react["default"].createElement(_innerContainer["default"], {
        disabled: disabled,
        readOnly: readOnly,
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox" // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        ,
        role: "combobox"
      }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: icon
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        error: error
      }, icon)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: !readOnly
      }, /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
        error: error,
        disabled: disabled
      })), /*#__PURE__*/_react["default"].createElement(_input["default"], {
        "aria-controls": this.listboxId,
        id: this.inputId,
        type: "text",
        name: name,
        value: value,
        error: error,
        onClick: this.handleInputClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder: placeholder,
        tabIndex: tabIndex,
        readOnly: true,
        isReadOnly: readOnly,
        disabled: disabled,
        required: required,
        "aria-describedby": errorMessageId,
        autoComplete: "off",
        ref: this.triggerRef,
        icon: icon,
        iconPosition: "left",
        variant: variant
      }), /*#__PURE__*/_react["default"].createElement(_InternalOverlay["default"], {
        isVisible: isOpen,
        positionResolver: positionResolver,
        onOpened: function onOpened() {
          return _this4.dropdownRef.current.focus();
        },
        triggerElementRef: function triggerElementRef() {
          return _this4.triggerRef;
        }
      }, /*#__PURE__*/_react["default"].createElement(_InternalDropdown["default"], {
        id: this.listboxId,
        isLoading: isLoading,
        value: valueInProps,
        onChange: this.handleChange,
        enableSearch: enableSearch,
        ref: this.dropdownRef
      }, children))), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: error
      }, /*#__PURE__*/_react["default"].createElement(_errorText["default"], {
        id: errorMessageId
      }, error)));
    }
  }]);
  return Picklist;
}(_react.Component);

exports.Component = Picklist;
Picklist.propTypes = {
  /** Text label for the PickList. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Describes the position of the PickList label. Options include left, center and right.
   * This value defaults to center. */
  labelAlignment: _propTypes["default"].oneOf(['left', 'center', 'right']),

  /** A boolean to hide the PickList label. */
  hideLabel: _propTypes["default"].bool,

  /** The content of the Picklist. Used to render the options
   * when the Picklist is open. */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),

  /** If is set to true, then is showed a loading symbol. */
  isLoading: _propTypes["default"].bool,

  /** Specifies the selected value of the Picklist. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    label: _propTypes["default"].string,
    name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    icon: _propTypes["default"].node,
    value: _propTypes["default"].any
  }), _propTypes["default"].string]),

  /**  The action triggered when click/select an option. */
  onChange: _propTypes["default"].func,

  /** The action triggered when the element is clicked. */
  onClick: _propTypes["default"].func,

  /** The action triggered when the element receives focus. */
  onFocus: _propTypes["default"].func,

  /** The action triggered when the element releases focus. */
  onBlur: _propTypes["default"].func,

  /** Specifies the tab order of an element (when the tab button is used for navigating). */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Text that is displayed when the field is empty, to prompt the user for a valid entry. */
  placeholder: _propTypes["default"].string,

  /** The name of the Picklist. */
  name: _propTypes["default"].string,

  /** Specifies that the Picklist must be filled out before submitting the form. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies that an option must be selected before submitting the form.
   * This value defaults to false. */
  required: _propTypes["default"].bool,

  /** Specifies that the Picklist element should be disabled. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** Specifies that the Picklist is read-only. This value defaults to false. */
  readOnly: _propTypes["default"].bool,

  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** The variant changes the appearance of the Picklist. Accepted variants include default,
   * and shaded. This value defaults to default. */
  variant: _propTypes["default"].oneOf(['default', 'shaded', 'bare']),

  /** If is set to true, then a search input to filter is showed. */
  enableSearch: _propTypes["default"].bool
};
Picklist.defaultProps = {
  label: undefined,
  children: null,
  isLoading: false,
  value: undefined,
  onChange: function onChange() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  tabIndex: undefined,
  placeholder: undefined,
  name: undefined,
  labelAlignment: 'center',
  hideLabel: false,
  id: undefined,
  error: null,
  disabled: false,
  readOnly: false,
  required: false,
  className: undefined,
  style: undefined,
  variant: 'default',
  enableSearch: false
};

var _default = (0, _withReduxForm["default"])(Picklist);

exports["default"] = _default;